module.exports = __webpack_public_path__ + "static/p4ktldr-wilco-ed9a1a45b8b37e8275f71eccba0b607d.jpg";